import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup,
  TextField,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { useState, useEffect } from 'react';
import { updateAmbassadorMessageAction } from 'src/redux/actions/ambassadorActions';
import palette from 'src/styles/palette';
import { AmbassadorUpdateMessagePayload } from 'src/models/FundraisingModel';

const EditAmbassadorMessageDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.editAmbassadorMessage]) {
        return state.dialog[DIALOGS.editAmbassadorMessage];
      }
      return { opened: false, payload: {} };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const { selected, fundraisingId } = payload ?? { selected: [] as string[], fundraisingId: 0 };

  const [message, setMessage] = useState('');
  const [sendTo, setSendTo] = useState('selected');

  useEffect(() => {
    if (opened) {
      setSendTo(!selected?.length ? 'all' : 'selected');
    }
  }, [opened]);

  const handleCancel = () => {
    setMessage('');
    dispatch(closeDialog({ dialog: DIALOGS.editAmbassadorMessage }));
  };

  const handleOk = () => {
    dispatch(updateAmbassadorMessageAction(fundraisingId, {
      ambassador_ids: selected,
      message,
      all: sendTo === 'all',
    } as AmbassadorUpdateMessagePayload));

    setMessage('');
    dispatch(closeDialog({ dialog: DIALOGS.editAmbassadorMessage }));
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      aria-labelledby="edit-ambassador-message"
      open={opened}>
      <DialogTitle id="edit-ambassador-message">
        <span style={{ color: palette.primary.main }}>
          {t(lang, 'menus.edit_ambassador_message')}
        </span>
      </DialogTitle>
      <DialogContent dividers>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">Send to</FormLabel>
          <RadioGroup
            row
            aria-label="format"
            name="format"
            value={sendTo}
            onChange={(e) => setSendTo(e.target.value)}>
            <FormControlLabel value="all" control={<Radio />} label="All" />
            <FormControlLabel value="selected" control={<Radio />} label="Selected" disabled={!selected?.length} />
          </RadioGroup>
        </FormControl>
        <TextField
          label="Message"
          multiline
          minRows={4}
          maxRows={8}
          fullWidth
          variant="outlined"
          value={message}
          onChange={(e) => setMessage(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.cancel')}
        </Button>
        <Button onClick={handleOk} color="primary" disabled={!message.trim()}>
          {t(lang, 'misc.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAmbassadorMessageDialog;
